const hvac = [
  {
    question: "How does an HVAC system work?",
    answer:
      "An HVAC system controls the heating, ventilation, and air conditioning in your home<IN_CITY_ZIP>. It circulates air, regulates temperature, and filters indoor air for comfort, health, and energy efficiency year-round.",
  },
  {
    question: "How much can I save with an energy-efficient HVAC system?",
    answer:
      "Upgrading to a high-efficiency HVAC system<IN_CITY_ZIP> can cut your energy bills by 20% to 40%, depending on your current setup, insulation, and usage. Smart thermostat integration can boost your savings even further.",
  },
  {
    question: "Do I need a permit to install or replace HVAC systems?",
    answer:
      "Yes. HVAC installations and major replacements<IN_CITY_ZIP> require city permits and inspections. Modern Build manages all permitting and ensures your system is fully code-compliant.",
  },
  {
    question: "How long does it take to install or replace an HVAC system?",
    answer:
      "Most HVAC installations<IN_CITY_ZIP> take 1 to 2 days. Larger homes or projects involving ductwork may take additional time. We provide a clear timeline before beginning any work.",
  },
  {
    question: "What types of HVAC systems do you offer?",
    answer:
      "We install central air systems, ductless mini-splits, heat pumps, gas furnaces, and hybrid HVAC systems<IN_CITY_ZIP>. Our team recommends the best solution based on your home’s layout, size, and energy goals.",
  },
  {
    question: "Can you repair my existing HVAC system?",
    answer:
      "Yes. We can connect you with licensed HVAC technicians in <IN_CITY_ZIP> who service and repair all major brands. Our trusted contractor partners handle issues like refrigerant leaks, poor airflow, thermostat malfunctions, and more.",
  },
  {
    question: "Are there rebates or incentives for HVAC upgrades?",
    answer:
      "Yes. Homeowners<IN_CITY_ZIP> may qualify for utility rebates, California energy efficiency incentives, and federal tax credits when upgrading to ENERGY STAR® certified systems. We help you apply and maximize savings.",
  },
  {
    question: "How much does a new HVAC system cost?",
    answer:
      "New HVAC systems typically range from $6,000 to $15,000<IN_CITY_ZIP> depending on equipment type, home size, and installation complexity. We offer free estimates tailored to your home and comfort needs.",
  },
  {
    question: "How do I know if my HVAC system needs replacement?",
    answer:
      "Common signs include uneven temperatures, high energy bills, frequent repairs, and systems older than 10–15 years. We offer honest assessments to help you decide between repair and replacement<IN_CITY_ZIP>.",
  },
  {
    question: "Do you offer maintenance plans for HVAC systems?",
    answer:
      "Yes. We offer seasonal HVAC maintenance plans<IN_CITY_ZIP> to keep your system running efficiently and catch issues early. Plans include inspections, filter changes, and performance checks.",
  },
];

export default hvac;
